import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {ReactNode} from 'react';

import {GRAY_LIGHT} from 'ui-library/Colors';

export function Table({children}: {children: ReactNode}): JSX.Element {
  return <div className={css(styles.table)}>{children}</div>;
}

export function Header({children}: {children: ReactNode}): JSX.Element {
  return <div className="simpleDivTable-header">{children}</div>;
}

export function HeaderCell({children}: {children: ReactNode}): JSX.Element {
  return <div className="simpleDivTable-headerCell">{children}</div>;
}

export function Row({children, isBeingEdited}: {children: ReactNode; isBeingEdited?: boolean}): JSX.Element {
  return (
    <div className={classNames('simpleDivTable-row', isBeingEdited ? 'is-beingEdited' : undefined)}>
      {children}
    </div>
  );
}

export function Cell({children}: {children: ReactNode}): JSX.Element {
  return <div className={classNames('simpleDivTable-cell', css(styles.cell))}>{children}</div>;
}

export function EmptyCell({children}: {children: ReactNode}): JSX.Element {
  return <div className={css(styles.emptyCell)}>{children}</div>;
}

const styles = StyleSheet.create({
  table: {
    width: '100%',
    border: 1,
    borderStyle: 'solid',
    borderColor: GRAY_LIGHT,
    borderRadius: 4,
  },
  cell: {
    paddingRight: '14px',
    wordWrap: 'break-word',
    ':last-child': {
      paddingRight: 0,
    },
    flex: '0 0 1',
    lineHeight: '28px',
  },
  emptyCell: {
    width: '100%',
    lineHeight: '28px',
  },
});
